import GeoPointDistanceComparatorEvaluator from "./GeoPointDistanceComparatorEvaluator.js";
export default class GeoPointFartherThanComparatorEvaluator extends GeoPointDistanceComparatorEvaluator {
  constructor(...args) {
    super(...args);
    this.not = true;
  }
}